import { useMemo } from 'react'

interface StampAnalyticsData {
  date: string
  value: number
}

const useFilterFutureDates = (data: StampAnalyticsData[] | undefined) => {
  const filteredData = useMemo(() => {
    if (!data) return []
    const today = new Date()
    today.setHours(0, 0, 0, 0)
    return data.filter((item) => new Date(item.date) < today)
  }, [data])

  return filteredData
}

export default useFilterFutureDates
